export enum GeneratedFileTypeModel {
	CustomerLocations = 1,
	FormularyNdc = 2,
	RebateAggregatorNdcRates = 3,
	RebateInvalidRecords = 4,
	RebateFileDuplicates = 5,
	RebateDuplicates = 6,
	RebatesHistory = 7,
	NotReviewedLocations = 8,
	Locations = 9,
	DrugTransactionsStatistic = 10,
	CustomerContractPayments = 11,
	NdcDestinations = 12,
	NdcDestinationHistory = 13,
	Customers = 14,
	SubmittedDetailedRows = 100,
	InvoicedDetailedRows = 101,
	PaidDetailedRows = 102,
	PayableDetailedRows = 103
}
